import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { UsersClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { LinkMailtoSharedComponent } from '@unity/shared/presentation/link-mailto-shared/link-mailto-shared.component';
import { SharedUserGridDto, SortConfig } from '@unity/utils/types';

@Component({
  selector: 'unity-grid-user-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    GridSharedComponent,
    LinkGridcellSharedComponent,
    LinkMailtoSharedComponent,
    ChipWorkflowStateSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-user-shared.component.html',
  styleUrl: './grid-user-shared.component.scss',
})
export class GridUserSharedComponent extends AbstractGridComponent<SharedUserGridDto> {
  private readonly usersClient = inject(UsersClient);

  public readonly $roleId = input.required<number>({ alias: 'roleId' });

  protected override resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const roleId = this.$roleId();
      return query && roleId ? { query, roleId } : undefined;
    },
    stream: ({ params: { roleId, query } }) =>
      this.usersClient.getAllForRoleAsDetailed(roleId, query.page, query.pageSize, query.orderBy, query.filter),
  });

  protected defaultSort: SortConfig[] = [
    {
      field: 'full_name',
      dir: 'asc',
    },
  ];
}
